import axios from "axios";
import { DonationURL } from "../../../../config/UrlEndPoint";

export const URL = `${DonationURL}bank_import`;

// Get ImportMutationBank All For use Combobox data
export function getImportMutationBankAll() {
  return axios.get(URL);
}

export function getImportMutationBankAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

// Get ImportMutationBank All For use Combobox data
export function getImportMutationBankAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getImportMutationBankById(id) {
  return axios.get(`${URL}/${id}`);
}

// items => filtered/sorted result for table data
export function findImportMutationBank(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the importMutationBank on the server
export function createImportMutationBank(importMutationBank) {
  return axios.post(URL, importMutationBank);
}

// UPDATE => PUT: update the importMutationBank on the server
export function proccesImportMutationBank(importMutationBank) {
  return axios.post(`${URL}/process`, importMutationBank);
}
